<template>
<!-- this modal is for vision care currently but can be used for other search terms in future-->
  <div className="hp-modal-basic-storybook">
    <hp5-modal-basic
      v-on:confirmed="handleClose"
      modal-id=""
      ref="modalref"
      confirm-button-hidden="true"
      title-text="Vison Coverage"
      title-size-selection="md"
      body-size-selection="md"
      :visible="isVision"
      dismissible="false"
      always-dismiss="false"
    >
      <hp5-semantic>
        <p>
          Eye care is separated into routine services and non-routine services:
        </p>
        <ul>
          <li>
            <b>Routine services</b> include vision exams – some plans also
            include coverage for glasses, contact lenses and other optical aids.
            Providers with the “Optometry” or “Optometry (Routine care)”
            specialty provide these services. Any routine eye care services your
            plan covers are through your preventive care benefits.
          </li>
          <li>
            <b>Non-routine services</b> include diagnosis and treatment of eye
            disease and eye injuries. Providers with the “Ophthalmology”
            specialty provide these services (they may also provide routine
            services, too, but we recommend contacting them first to confirm).
            To confirm your coverage for eye care, check your plan details.
          </li>
        </ul>
        <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
        <hp5-horizontal-rule style-selection="basic" />
        <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>

        <div class="buttonContainer">
          <hp5-button-decorator type="secondary" size="md">
            <button type="button" v-on:click="confirm">Got it</button>
          </hp5-button-decorator>
          <hp5-call-to-action
            size="md"
            type="primary"
            element-id="unique-value"
            target="_blank"
            icon-name="system-add"
          >
           <a href="/my/plan-overview/coverage.html">See Coverage Details</a>
          </hp5-call-to-action>
        </div>
        <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
      </hp5-semantic>
    </hp5-modal-basic>
  </div>
</template>

<script setup>
const props = defineProps({
  isVision: Boolean,
});
const model = useFCPModel();
const { context, isVision } = useFCPModel();

const modalref = ref(null);

const emit = defineEmits(["confirmed", "dismiss"]);

const confirm = (event) => {
  if (event) {
    emit("confirmed", event);
    handleClose();
  }
};

onMounted(() => {
  modalref.value.addEventListener("confirmed", handleClose);
});

const handleClose = (event) => {
  model.isVision.value = false;
};
</script>

<style lang="scss" scoped>
.buttonContainer {
  float: right;

  button {
    margin-right: 18px;
    width: 100px;
  }
}
</style>
